import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CodeIcon from '@mui/icons-material/Code';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import BuildIcon from '@mui/icons-material/Build';
import ChatIcon from '@mui/icons-material/Chat';

// 图标映射组件
const IconMapper = ({ iconName, ...props }) => {
  switch (iconName) {
    case 'HelpOutline':
      return <HelpOutlineIcon {...props} />;
    case 'Code':
      return <CodeIcon {...props} />;
    case 'BarChart':
      return <BarChartIcon {...props} />;
    case 'People':
      return <PeopleIcon {...props} />;
    case 'School':
      return <SchoolIcon {...props} />;
    case 'Build':
      return <BuildIcon {...props} />;
    case 'Chat':
      return <ChatIcon {...props} />;
    default:
      return <HelpOutlineIcon {...props} />;
  }
};

export default IconMapper; 